export default __webpack_public_path__ + "static/media/overview.810d9322.svg";